__turbopack_context__.v({
  "condition-item": "new-password-card-module-scss-module__Ri9DaG__condition-item",
  "conditions": "new-password-card-module-scss-module__Ri9DaG__conditions",
  "footer": "new-password-card-module-scss-module__Ri9DaG__footer",
  "info": "new-password-card-module-scss-module__Ri9DaG__info",
  "input": "new-password-card-module-scss-module__Ri9DaG__input",
  "pass": "new-password-card-module-scss-module__Ri9DaG__pass",
  "title": "new-password-card-module-scss-module__Ri9DaG__title",
});
